var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Circle_Black",
    "data-name": "Circle Black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.672,
    height: 28.672,
    viewBox: "0 0 28.672 28.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M14.336,28.672A14.34,14.34,0,0,1,8.756,1.127a14.34,14.34,0,0,1,11.16,26.419A14.247,14.247,0,0,1,14.336,28.672Zm2.915-14.421c1.727,0,1.727,1.642,1.727,2.84V22.3h3.339V16.424a6.737,6.737,0,0,0-.73-3.629,3.518,3.518,0,0,0-3.26-1.468l-.131,0a3.494,3.494,0,0,0-3.015,1.73h-.061V11.59H11.931V22.3h3.322V17C15.253,15.721,15.48,14.251,17.251,14.251ZM6.514,11.59V22.3H9.843V11.59ZM8.18,6.271A1.929,1.929,0,1,0,10.109,8.2,1.931,1.931,0,0,0,8.18,6.271Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircle);
export default __webpack_public_path__ + "static/media/linkedin-circle.4526b08ea9ce054840f86946624a2e4c.svg";
export { ForwardRef as ReactComponent };